module.exports = __webpack_public_path__ + "d01557f9f6cede62429e7175156c3f54.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/wrinkles/wrinkles-1b.jpg
 ** module id = 448
 ** module chunks = 0
 **/